/**
 * 精灵入口。
 *
 * 单位与建筑由 `mesh3d/` 在启动时从程序化低模烘焙为等距精灵
 * （技术文档 §6.2：3D → 多角度精灵图）。本文件保留建造预览底面，
 * 并转发烘焙结果，渲染器其余部分只依赖这里的接口。
 */

import { Texture } from 'pixi.js';
import { HALF_H, HALF_W } from './iso.ts';
import {
  getSprite as getBaked,
  getSpriteCanvas,
  bakeAllSprites,
  dirFromVector,
  UNIT_DIRS,
  WALK_FRAMES,
  getProjectileSprite,
  hasRecoilAnim,
  hasDriveAnim,
  type BakedSprite,
} from './mesh3d/baker.ts';

export type { BakedSprite };
export {
  getSpriteCanvas,
  bakeAllSprites,
  dirFromVector,
  UNIT_DIRS,
  WALK_FRAMES,
  getProjectileSprite,
  hasRecoilAnim,
  hasDriveAnim,
};

export function getSprite(typeId: number, owner: number, dir = 0, cargo = false, frame = 0): BakedSprite {
  return getBaked(typeId, owner, dir, cargo, frame);
}

function makeCanvas(w: number, h: number): [HTMLCanvasElement, CanvasRenderingContext2D] {
  const c = document.createElement('canvas');
  c.width = Math.ceil(w);
  c.height = Math.ceil(h);
  const ctx = c.getContext('2d')!;
  ctx.imageSmoothingEnabled = true;
  return [c, ctx];
}

function diamond(ctx: CanvasRenderingContext2D, cx: number, cy: number, w: number, h: number): void {
  ctx.beginPath();
  ctx.moveTo(cx, cy - h / 2);
  ctx.lineTo(cx + w / 2, cy);
  ctx.lineTo(cx, cy + h / 2);
  ctx.lineTo(cx - w / 2, cy);
  ctx.closePath();
}

/** 建造预览用的半透明底面纹理 */
export function makeFootprintTexture(fp: number, ok: boolean): Texture {
  const bw = fp * HALF_W * 2;
  const bh = fp * HALF_H * 2;
  const [c, ctx] = makeCanvas(bw + 4, bh + 4);
  ctx.fillStyle = ok ? 'rgba(90, 220, 130, 0.28)' : 'rgba(230, 70, 70, 0.28)';
  ctx.strokeStyle = ok ? 'rgba(160, 255, 190, 0.95)' : 'rgba(255, 130, 130, 0.95)';
  ctx.lineWidth = 2;
  diamond(ctx, bw / 2 + 2, bh / 2 + 2, bw, bh);
  ctx.fill();
  ctx.stroke();
  // 格线，方便对齐
  ctx.strokeStyle = ok ? 'rgba(140,255,180,0.25)' : 'rgba(255,120,120,0.25)';
  ctx.lineWidth = 1;
  for (let i = 1; i < fp; i++) {
    const t = i / fp;
    const x0 = 2 + t * bw;
    ctx.beginPath();
    ctx.moveTo(x0, 2 + bh / 2 - t * bh / 2);
    ctx.lineTo(x0 - bw / 2, 2 + bh / 2 + (1 - t) * bh / 2);
    ctx.stroke();
  }
  return Texture.from(c);
}
